import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Table, TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
} from '@mui/material';
import { DatePicker } from "@mui/x-date-pickers";
import React, { useEffect, useState } from 'react';
import MySelect from './MySelect';
import { Editor } from 'react-draft-wysiwyg';
import { convertFromHTML, EditorState, convertToRaw } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import ContentState from 'draft-js/lib/ContentState';
import htmlToDraft from 'html-to-draftjs';

const MyForm = (props) => {
  const [editedValue, setEditedValue] = useState('');
  const [editorState, setEditorState] = useState(() => {
    if (props.data.key !== 'LEGAL_NOTICE' && props.data.key !== 'PARTICULAR_NOTICE') {
      return;
    }
    let blocksFromHtml = htmlToDraft(props.data.value);
    let { contentBlocks, entityMap } = blocksFromHtml;
    return EditorState.createWithContent(
        ContentState.createFromBlockArray(contentBlocks, entityMap)
    );
  });

  const [editorInit, setEditorInit] = useState(false);

  useEffect(() => {
    if (props.data.key !== 'LEGAL_NOTICE' && props.data.key !== 'PARTICULAR_NOTICE') {
      return ;
    }
    if (props.data.value && !editorInit) {
      let blocksFromHtml = htmlToDraft(props.data.value);
      let { contentBlocks, entityMap } = blocksFromHtml;
      setEditorState(
        EditorState.createWithContent(
          ContentState.createFromBlockArray(contentBlocks, entityMap)
        )
      );
      setEditorInit(true);
    }
  }, [props.data.value]);

  useEffect(() => {
    if (props.data.key !== 'LEGAL_NOTICE' && props.data.key !== 'PARTICULAR_NOTICE') {
      return ;
    }
    if (editorState.getCurrentContent().hasText()) {
      props.onChange({ target: { name: 'value', value: draftToHtml(convertToRaw(editorState.getCurrentContent())) } });
    }
  }, [editorState]);

  const handleBlur = (form, event, rowIndex, cellIndex) => {
    form.rows[rowIndex][cellIndex].label = event.target.innerText;
    props.onCellEdit(form, rowIndex, cellIndex, event.target.innerText);
  };
  return (<>
    {
      props.form.map((f) => {
        switch (f.type) {
          case 'select':
            return (
              f.options &&
                <MySelect
                  id={f.id}
                  multiple={f.multiple}
                  name={f.name}
                  value={f.value}
                  label={f.label}
                  disabled={f.disabled}
                  handleChange={(e) => props.onChange(e)}
                  datas={f.options}
                  style={f.style}
                  displayLabel={f.displayLabel}
                  formControlStyle={f.formControlStyle}
                  labelClass={f.labelClass}
                  firstValue={f.firstValue}
                  noNull={f.noNull}
                  disableClass={f.disableClass}
                />
            );
          case 'password':
            return (
              <TextField
                key={f.id}
                label={f.label}
                type='password'
                name={f.name}
                value={props.data[f.id] || ''}
                onChange={(e) => props.onChange(e)}
                style={f.style ? f.style : { width: '90%', minWidth: '250px', margin: 'auto' }}
                autoComplete={'off'}
                required={f.required}
                disabled={f.disabled}
                error={f.pattern && props.data[f.id] ? !f.pattern.test(String(props.data[f.id]).toLowerCase()) : null}
                helperText={f.pattern && props.data[f.id] && !f.pattern.test(String(props.data[f.id]).toLowerCase()) ? f.errorLabel : ''}
                placeholder={f.placeholder}
                multiline={f.multiline}
                maxRows={f.maxRows ? f.maxRows : null}
                InputLabelProps={{
                  shrink: true,
                }}
                InputProps={{
                  readOnly: f.readOnly,
                }}
                inputProps={{
                  maxLength: f.maxLength,
                }}
                variant={props.variant || 'standard'}
              />
            );
          case 'date':
            return (
              <DatePicker
                key={f.id}
                label={f.label}
                name={f.name}
                value={props.data[f.id] || ''}
                onChange={(e) => props.onChange(e, f.name)}
                autoComplete={'off'}
                required={f.required}
                disabled={f.disabled}
                error={f.pattern && props.data[f.id] ? !f.pattern.test(String(props.data[f.id]).toLowerCase()) : null}
                helperText={f.pattern && props.data[f.id] && !f.pattern.test(String(props.data[f.id]).toLowerCase()) ? f.errorLabel : ''}
                placeholder={f.placeholder}
                multiline={f.multiline}
                maxRows={f.maxRows ? f.maxRows : null}
                InputLabelProps={{
                  shrink: true,
                }}
                InputProps={{
                  readOnly: f.readOnly,
                }}
                variant={props.variant || 'standard'}
                renderInput={(params) => <TextField {...params}  style={f.style ? f.style : { width: '90%', minWidth: '250px', margin: 'auto' }} error={!f.hideError} />}
                inputVariant="outlined"
              />

            );
          case 'table':
            return (
              <Table id={f.id}>
                <TableHead>
                  <TableRow>
                    {f.columns.map((c) => (
                      <TableCell align={c.align} style={c.style}>{c.label}</TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {f.rows.map((row, rowIndex) => (
                    <TableRow>
                      {row.map((cell, cellIndex) => (
                        <TableCell
                          align={cell.align}
                          style={cell.style}
                          contentEditable={cell.editable}
                          onBlur={(event) => handleBlur(f, event, rowIndex, cellIndex)}
                          suppressContentEditableWarning={true}
                        >
                          {cell.label}
                        </TableCell>
                      ))}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            );
          case 'number':
            return (
                <TextField
                  key={f.id}
                  label={f.label}
                  type="tel"
                  name={f.name}
                  value={props.data[f.id] || ''}
                  onChange={(e) => props.onChange(e)}
                  style={f.style ? f.style : { width: '90%', minWidth: '250px', margin: 'auto' }}
                  autoComplete={'off'}
                  required={f.required}
                  disabled={f.disabled}
                  error={f.pattern && props.data[f.id] ? !f.pattern.test(String(props.data[f.id]).toLowerCase()) : null}
                  helperText={f.pattern && props.data[f.id] && !f.pattern.test(String(props.data[f.id]).toLowerCase()) ? f.errorLabel : ''}
                  placeholder={f.placeholder}
                  multiline={f.multiline}
                  maxRows={f.maxRows ? f.maxRows : null}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    readOnly: f.readOnly,
                  }}
                  inputProps={{
                    maxLength: f.maxLength,
                    inputMode: 'numeric'
                  }}
                  variant={props.variant || 'standard'}
                />
              );
          case 'editor':
            return (
              <>
                <Editor
                  editorState={editorState}
                  wrapperClassName="demo-wrapper"
                  editorClassName="demo-editor"
                  onEditorStateChange={setEditorState}
                  editorStyle={{height: '250px'}}
                  />
              </>
            );
          default:
            return (
              <TextField
                key={f.id}
                label={f.label}
                type='text'
                name={f.name}
                value={props.data[f.id] || ''}
                onChange={(e) => props.onChange(e)}
                style={f.style ? f.style : { width: '90%', minWidth: '250px', margin: 'auto' }}
                autoComplete={'off'}
                required={f.required}
                disabled={f.disabled}
                error={f.pattern && props.data[f.id] ? !f.pattern.test(String(props.data[f.id]).toLowerCase()) : null}
                helperText={f.pattern && props.data[f.id] && !f.pattern.test(String(props.data[f.id]).toLowerCase()) ? f.errorLabel : ''}
                placeholder={f.placeholder}
                multiline={f.multiline}
                maxRows={f.maxRows ? f.maxRows : null}
                InputLabelProps={{
                  shrink: true,
                }}
                InputProps={{
                  readOnly: f.readOnly,
                }}
                inputProps={{
                  maxLength: f.maxLength,
                }}
                variant={props.variant || 'standard'}
              />
            );
        }
      })
    }

  </>);

};

export default MyForm;
